import React from 'react';

/**
 * Компонент боковой панели с ипотечными программами
 */
const MortgageProgramsSidebar = ({ formData, setFormData, creditTypes }) => {
  // Обработчик выбора программы
  const handleProgramSelect = (creditTypeId) => {
    // Симулируем событие изменения для поля creditType
    const selectedType = creditTypes.find(type => type.id === creditTypeId);
    if (selectedType) {
      // Обновляем тип кредита
      setFormData(prev => {
        const newState = { ...prev, creditType: creditTypeId };
        
        // Если текущая ставка является стандартной для какого-либо типа кредита
        // или пуста, обновляем ее на ставку выбранного типа
        const currentRate = parseFloat(prev.interestRate) || 0;
        const isRateDefault = creditTypes.some(ct => currentRate === ct.defaultRate);
        if (isRateDefault || !prev.interestRate || currentRate <= 0) {
          newState.interestRate = selectedType.defaultRate.toString();
        }
        
        return newState;
      });
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Льготные программы</h3>
      <div className="space-y-2">
        {creditTypes.map(type => (
          <button
            key={type.id}
            type="button"
            role="radio"
            aria-checked={formData.creditType === type.id}
            className={`w-full flex items-center p-3 rounded-lg border text-left transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-gray-800 focus:ring-indigo-500 ${
              formData.creditType === type.id
                ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-900/30 dark:border-indigo-600 ring-1 ring-indigo-500 dark:ring-indigo-600'
                : 'border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700/50 hover:border-gray-300 dark:hover:border-gray-600'
            }`}
            onClick={() => handleProgramSelect(type.id)}
          >
            <div className="flex-1">
              <div className={`font-medium ${formData.creditType === type.id ? 'text-indigo-700 dark:text-indigo-300' : 'text-gray-900 dark:text-white'}`}>
                {type.name}
              </div>
              <div className={`text-xs ${formData.creditType === type.id ? 'text-indigo-600 dark:text-indigo-400' : 'text-gray-500 dark:text-gray-400'}`}>
                Ставка от {type.defaultRate}%
              </div>
            </div>
            {/* Визуальный индикатор выбранного элемента */}
            {formData.creditType === type.id && (
              <div aria-hidden="true" className="ml-2 w-2.5 h-2.5 bg-indigo-500 dark:bg-indigo-400 rounded-full flex-shrink-0"></div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MortgageProgramsSidebar;